import { render, staticRenderFns } from "./HomeFeaturedLink.vue?vue&type=template&id=04c1a35c&scoped=true"
import script from "./HomeFeaturedLink.vue?vue&type=script&lang=js"
export * from "./HomeFeaturedLink.vue?vue&type=script&lang=js"
import style0 from "./HomeFeaturedLink.vue?vue&type=style&index=0&id=04c1a35c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c1a35c",
  null
  
)

export default component.exports